import { LuArrowUpRight, LuBadgePercent, LuTicket } from "react-icons/lu";

import { formatPrice } from "../../utils/formatPrice";
import styles from "./OfferCard.module.scss";

export default function OfferCard({ offer, variant = "home" }) {
  const discountLabel = offer.discount || (variant === "home" ? "Oferta" : null);
  const formattedPrice = formatPrice(offer.price);
  const formattedOldPrice = formatPrice(offer.oldPrice);
  const TitleTag = variant === "page" ? "h2" : "h3";

  return (
    <article className={`${styles.card} ${styles[variant] || ""}`}>
      <div className={styles.imageBox}>
        {offer.image ? (
          <img src={offer.image} alt={offer.title} />
        ) : (
          <span className={styles.noImage}>Sin imagen</span>
        )}
      </div>

      <div className={styles.body}>
        {discountLabel && <span className={styles.discount}>{discountLabel}</span>}
        <TitleTag className={styles.title}>{offer.title}</TitleTag>

        {offer.description && (
          <p className={styles.code}>
            <LuTicket aria-hidden="true" />
            <span>{offer.description}</span>
          </p>
        )}

        {offer.store && (
          <span className={styles.store}>
            <LuBadgePercent aria-hidden="true" />
            {offer.store}
          </span>
        )}

        {(formattedPrice || formattedOldPrice) && (
          <div className={styles.priceRow}>
            {formattedPrice && <strong className={styles.price}>{formattedPrice}</strong>}
            {formattedOldPrice && <span className={styles.oldPrice}>{formattedOldPrice}</span>}
          </div>
        )}

        <a
          href={offer.link}
          target="_blank"
          rel="noreferrer"
          className={styles.button}
        >
          Ver oferta
          <LuArrowUpRight aria-hidden="true" />
        </a>
      </div>
    </article>
  );
}
